import { Component } from '@angular/core';
import { ILoadingOverlayAngularComp } from 'ag-grid-angular';
import { ILoadingOverlayParams } from 'ag-grid-community';

@Component({
  selector: 'app-loading-overlay',
  template: `
    <div class="ag-overlay-loading-center d-flex">
      <!-- <object
        style="height:100px; width:100px"
        type="image/svg+xml"
        data="https://ag-grid.com/images/ag-grid-loading-spinner.svg"
        aria-label="loading"
      ></object> -->
      <mat-spinner diameter="20"></mat-spinner>
      <div class="pl-1">{{ params.loadingMessage }}</div>
    </div>
  `,
})
export class CustomLoadingOverlayComponent implements ILoadingOverlayAngularComp {
  public params!: ILoadingOverlayParams & { loadingMessage: string };

  agInit(params: ILoadingOverlayParams & { loadingMessage: string }): void {
    this.params = params;
  }
}